


























































































































import { Vue, Component } from "vue-property-decorator";
import { DataTableHeader } from "vuetify";
import { $api } from "@/services/ApiService";
import { Client, ClientState } from "bancojs";
import AgDataTable, { AgDataTableOptions } from "@/components/AgDataTable.vue";

@Component({
  components: {
    AgDataTable,
  },
})
export default class AdminClientsIndex extends Vue {
  async created() {
    this.loadData();
  }

  async loadData() {
    try {
      this.table.loading = true;
      const res = await $api.client.admin.clients.find({}).toPromise();
      this.table.data = res.content;
    } catch (err) {
      console.log(err);
    } finally {
      this.table.loading = false;
    }
  }

  getStateString(val: ClientState) {
    return val === "ACTIVE" ? "Activo" : "Inactivo";
  }

  openRemove(item: Client) {
    this.table.selected = item;
  }

  closeRemove() {
    this.table.selected = null;
    this.dialog.valid = false;
    this.dialog.confirm = null;
  }

  get removeDialog() {
    return !!this.table.selected;
  }

  rules = {
    required: (val: any) => !!val || "Campo requerido.",
    matches: (val: string) =>
      (this.table.selected && this.table.selected.id == val) ||
      "El ID de cliente no es correcto.",
  };

  async removeUser(id: string) {
    try {
      this.dialog.loading = true;
      await $api.client.admin.clients.destroy(id).toPromise();
      this.dialog.loading = false;
      this.closeRemove();
      await this.loadData();
    } catch (err) {
      console.log(err);
      this.dialog.loading = false;
      this.closeRemove();
    }
  }

  dialog: {
    loading: boolean;
    valid: boolean;
    confirm: string | null;
  } = {
    loading: false,
    valid: false,
    confirm: null,
  };

  table: {
    loading: boolean;
    selected: Client | null;
    data?: Client[];
    options: AgDataTableOptions[];
    headers?: DataTableHeader[];
  } = {
    loading: true,
    selected: null,
    data: undefined,
    options: [
      {
        header: {
          text: "#",
          value: "$index",
          width: 60,
          filterable: false,
          sortable: false,
        },
        row: {
          type: "INDEX",
        },
      },
      {
        header: {
          text: "ID",
          value: "id",
          class: "text-no-wrap",
          width: 500,
        },
        row: {
          type: "LINK",
          to: "{id}/edit",
          append: true,
        },
      },
      {
        header: {
          text: "Name",
          value: "name",
          class: "text-no-wrap",
        },
        row: {
          type: "TEXT",
        },
      },
      {
        header: {
          text: "Email",
          value: "email",
          class: "text-no-wrap",
        },
        row: {
          type: "TEXT",
        },
      },
      {
        header: {
          text: "Estado",
          value: "state",
          class: "text-no-wrap",
        },
        row: {
          type: "CHIP",
          label: true,
          color: {
            ACTIVE: "success",
            INACTIVE: "error",
          },
          transform: this.getStateString,
        },
      },
      {
        header: {
          text: "",
          class: "text-no-wrap",
          value: "$options",
          sortable: false,
          filterable: false,
        },
        row: {
          type: "OPTIONS",
          options: [
            {
              label: "Editar",
              icon: "mdi-pencil",
              link: "{id}/edit",
              append: true,
            },
            {
              label: "Eliminar",
              icon: "mdi-delete",
              action: (item: Client) => {
                this.openRemove(item);
              },
            },
          ],
        },
      },
    ],
  };
}
